import React from "react";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import styles from "./callhistory.module.css";
import ContactAvatar from "./contactavatar";
import { formatPhone, formatRoomTime, statusOf } from "./callhistoryformat";
import { formatDuration } from "../phoneinbound/receiverrow";

const statusClass : { [kind : string] : string } = {
    callback : styles.statusCallback,
    manual : styles.statusManual,
    incall : styles.statusIncall,
    done : styles.statusDone,
    noanswer : styles.statusNoanswer,
    waiting : styles.statusWaiting,
    hidden : styles.statusHidden,
    none : styles.statusNone
};

//좌측 리스트 한 행: [아바타] [이름+재원칩 / 상태 한 줄] [시간 / 댓글뱃지]
const ContactRow : React.FC<any> = (props) => {
    const c = props.contact;
    const status = statusOf(c, props.now, formatDuration);
    const isCallback = !c.hidden && !!c.callbackNeeded;
    const rowClass = [
        styles.row,
        isCallback ? styles.rowCallback : "",
        props.selected ? styles.rowSelected : "",
        c.hidden ? styles.rowHidden : ""
    ].join(" ");

    return (
        <div className={rowClass} onClick={() => props.onSelect(c.phoneNumber)}>
            <ContactAvatar contact={c} size={38} />
            <div className={styles.rowMain}>
                <div className={`${styles.name} ${isCallback ? styles.nameCallback : ""}`} title={formatPhone(c.phoneNumber)}>
                    {c.displayName || formatPhone(c.phoneNumber)}
                    {c.isEnrolled ? <span className={styles.enrolledChip}>재원</span> : ""}
                </div>
                <div className={styles.rowStatus}>
                    <span className={statusClass[status.kind] || ""}>{status.line1}</span>
                    {status.line2 ? <span className={styles.rowStatusSub}> · {status.line2}</span> : ""}
                </div>
            </div>
            <div className={styles.rowSide}>
                <div className={`${styles.recent} ${isCallback ? styles.recentCallback : ""}`}>
                    {formatRoomTime(c.lastContactAt)}
                </div>
                <span
                    className={`${styles.commentBtn} ${c.commentCount > 0 ? styles.commentBtnActive : ""}`}
                    onClick={(e) => { e.stopPropagation(); props.onComment(c); }}
                    title="댓글"
                >
                    {c.commentCount > 0 ? <span>{c.commentCount}</span> : ""}
                    <ChatBubbleOutlineIcon sx={{ fontSize: 15 }} />
                </span>
            </div>
        </div>
    );
};

export default React.memo(ContactRow, (prev, next) => {
    if (prev.contact !== next.contact || prev.selected !== next.selected) return false;
    //통화중/콜백 경과 표시가 있는 행만 1초 틱에 반응, 나머지는 분 단위로만
    const live = !!next.contact.inCallSince;
    if (live) return prev.now === next.now;
    return Math.floor(prev.now / 60000) === Math.floor(next.now / 60000);
});
